const GEOREF_BASE = 'https://apis.datos.gob.ar/georef/api';

export interface GeorefProvincia {
  readonly id: string;
  readonly nombre: string;
}

export interface GeorefLocalidad {
  readonly id: string;
  readonly nombre: string;
}

interface ProvinciasResponse {
  readonly provincias: GeorefProvincia[];
}

interface LocalidadesResponse {
  readonly localidades: GeorefLocalidad[];
}

function normalizeForMatch(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function matchProvinciaNombre(
  provincias: readonly GeorefProvincia[],
  stateLabel: string,
): GeorefProvincia | undefined {
  const target = normalizeForMatch(stateLabel);
  return provincias.find((p) => normalizeForMatch(p.nombre) === target);
}

export function matchLocalidadNombre(
  localidades: readonly GeorefLocalidad[],
  cityLabel: string,
): GeorefLocalidad | undefined {
  const target = normalizeForMatch(cityLabel);
  return localidades.find((l) => normalizeForMatch(l.nombre) === target);
}

export async function fetchProvinciasArgentina(): Promise<GeorefProvincia[]> {
  const url = `${GEOREF_BASE}/provincias?campos=id,nombre&max=30`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Georef provincias: ${response.status}`);
  }
  const data = (await response.json()) as ProvinciasResponse;
  const list = data.provincias ?? [];
  return [...list].sort((a, b) => a.nombre.localeCompare(b.nombre, 'es'));
}

export async function fetchLocalidadesByProvincia(provinciaId: string): Promise<GeorefLocalidad[]> {
  const params = new URLSearchParams({
    provincia: provinciaId,
    campos: 'id,nombre',
    max: '5000',
  });
  const url = `${GEOREF_BASE}/localidades?${params.toString()}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Georef localidades: ${response.status}`);
  }
  const data = (await response.json()) as LocalidadesResponse;
  const list = data.localidades ?? [];
  return [...list].sort((a, b) => a.nombre.localeCompare(b.nombre, 'es'));
}
